module.exports = __webpack_public_path__ + "img/bg_Strong.3df6de69.png";